module.exports = __webpack_public_path__ + "img/module6_8.e9f5d7de.png";